import clsx from "clsx"
import { FC, memo } from "react"
import { IUserRuneBalance } from "."
import styles from "./UserRuneBalance.module.scss"
import { RUNE_TYPE, UserRuneBalanceItem } from "./ui"

const UserRuneBalanceComponent: FC<IUserRuneBalance> = ({
  speed,
  luck,
  stamina
}) => {
  return (
    <div className={clsx(styles.UserRuneBalance)}>
      <UserRuneBalanceItem runeType={RUNE_TYPE.SPEED} {...speed} />
      <UserRuneBalanceItem runeType={RUNE_TYPE.LUCK} {...luck} />
      <UserRuneBalanceItem runeType={RUNE_TYPE.STAMINA} {...stamina} />
    </div>
  )
}

export const UserRuneBalance = memo(UserRuneBalanceComponent)
